/* eslint-disable react/prop-types */
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import AuthShowcase from "@/components/auth/AuthShowcase";
import { ArrowRight, CheckCircle, EnvelopeSimple } from "@phosphor-icons/react";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/forgot-password`, { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      // Backend SEMPRE retorna 200 — só cai aqui em erro de rede
      toast.error("Não consegui contatar o servidor. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-white text-slate-900 flex overflow-hidden">
      <AuthShowcase />
      <div className="relative flex-1 lg:basis-1/2 lg:grow-0 lg:shrink-0 min-h-screen flex flex-col">
        <main className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-[400px]" data-testid="forgot-password-page">

            {!submitted ? (
              <>
                <div className="text-center mb-6">
                  <div className="w-12 h-12 mx-auto rounded-full bg-slate-100 flex items-center justify-center mb-4">
                    <EnvelopeSimple size={20} weight="regular" className="text-slate-600" />
                  </div>
                  <h1 className="font-heading text-[24px] font-semibold tracking-[-0.02em] text-slate-900 leading-tight">
                    Recuperar acesso
                  </h1>
                  <p className="text-[13px] text-slate-500 mt-1.5">
                    Vamos te enviar um link para criar uma nova senha.
                  </p>
                </div>
                <form
                  onSubmit={submit}
                  data-testid="forgot-form"
                  className="bg-white border border-slate-200 rounded-[14px] px-6 pt-5 pb-5 shadow-[0_1px_0_rgba(15,23,42,0.03),0_8px_28px_-12px_rgba(15,23,42,0.07)]"
                >
                  <label className="block text-[10px] uppercase tracking-[0.18em] text-slate-500 font-medium mb-1.5">Email</label>
                  <input
                    type="email"
                    required
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu@email.com"
                    data-testid="forgot-email-input"
                    className="w-full h-[42px] bg-[#FAFBFC] border border-[#E5E9EF] rounded-[10px] px-3 text-[13.5px] outline-none focus:bg-white focus:border-slate-900 focus:ring-2 focus:ring-slate-900/5"
                  />
                  <button
                    type="submit"
                    disabled={loading || !email.trim()}
                    data-testid="forgot-submit-btn"
                    className="mt-5 w-full h-11 bg-slate-900 hover:bg-slate-700 disabled:opacity-60 text-white rounded-[10px] text-[13px] font-semibold inline-flex items-center justify-center gap-2 transition-colors"
                  >
                    {loading ? "Enviando…" : (<>Enviar link de recuperação <ArrowRight size={13} weight="bold" /></>)}
                  </button>
                </form>
              </>
            ) : (
              <div className="text-center" data-testid="forgot-success">
                <div className="w-14 h-14 mx-auto rounded-full bg-emerald-50 flex items-center justify-center mb-4">
                  <CheckCircle size={26} weight="fill" className="text-emerald-600" />
                </div>
                <h1 className="font-heading text-[22px] font-semibold tracking-[-0.02em] text-slate-900">
                  Pronto! Verifique seu email
                </h1>
                <p className="text-[13.5px] text-slate-500 mt-2 leading-relaxed">
                  Se <span className="font-medium text-slate-700">{email}</span> estiver cadastrado, em instantes você vai receber um link para criar uma nova senha.
                </p>
                <p className="text-[11.5px] text-slate-400 mt-3">
                  O link expira em 60 minutos.
                </p>
              </div>
            )}

            <p className="text-[12px] text-slate-500 text-center mt-5">
              Lembrou da senha?{" "}
              <Link to="/login" data-testid="forgot-back-to-login" className="text-slate-900 font-semibold hover:underline underline-offset-[5px]">
                Voltar para o login
              </Link>
            </p>
          </div>
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
